import { render, staticRenderFns } from "./AddEditFollowUpDialogComponent.vue?vue&type=template&id=6ef8e738&"
import script from "./AddEditFollowUpDialogComponent.vue?vue&type=script&lang=js&"
export * from "./AddEditFollowUpDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports